import { render, staticRenderFns } from "./PartsPointFinder.vue?vue&type=template&id=4c040277"
import script from "./PartsPointFinder.vue?vue&type=script&lang=js"
export * from "./PartsPointFinder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../themes/custom/ef2_custom/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports